export * from './contact/contact.selectors';
export * from './recipient/recipient.selectors';
import { createSelector } from '@ngrx/store';
import { selectAllContacts } from './contact/contact.selectors';
import { selectRecipientIds } from './recipient/recipient.selectors';
import { getUniqueUserId } from './utils';

export const selectNonRecipients = createSelector(
  selectAllContacts,
  selectRecipientIds,
  (contacts, recipientIds: (string | number)[]) =>
    contacts.filter(
      (contact) =>
        !recipientIds
          .filter((id): id is string => typeof id === 'string')
          .includes(getUniqueUserId(contact)),
    ),
);
